import ServiceBase from '../ServiceBase';

export default class ProjectLanguageConfigurationService extends ServiceBase {

    getProjectLanguagesConfiguration({ projectID }) {
        return this.request('get', 'admin/projectLanguagesConfiguration/getProjectLanguagesConfiguration', { projectID });
    }

    updateProjectLanguagesConfiguration({ projectID, projectLanguageID, languageID, isEnabled, isVisible }) {
        return this.request('post', 'admin/projectLanguagesConfiguration/updateProjectLanguagesConfiguration', { projectID, projectLanguageID, languageID, isEnabled, isVisible });
    }
}
